import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import { Box } from 'grommet/components/Box';
import { Button } from 'grommet/components/Button';
import { sessionExpired } from '../Utils/Utility';
import ModalErrorTimeout from './ModalErrorTimeout';


class MainButtons extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            status:'',
            showTimeoutModal: false
        }
        this.keepAlive = this.keepAlive.bind(this);

    }



    keepAlive(path, id) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;

        sessionExpired(function (data, status) {
            sessionStorage.setItem("data_keepAlive", data);
            sessionStorage.setItem("status_keepAlive", status);
            self.setState({
                status: status
            }, function() {
                if(status === 200) {
                    if(id === 0) {
                        this.props.history.push("/Home/Movimenti")
                    } else if (id === 1) {
                        this.props.history.push("/Home/Riepilogo")
                    } else if (id === 2) {
                        this.props.history.push("/Home/DettaglioDifferenzeContabili")
                    } else if (id === 3) {
                        this.props.history.push("/Home/AddebitiContestazioni")
                    }
                }
            })
        }, function (error) {
            self.setState({
                status: error
            }, function(){
                 if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                } else {
                    this.props.history.push("/ErrorPage")
                }
            })

        }, token, ids, path);
    }


    render() {

        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box className='generic' direction='row' justify='center'>
                    <Box className='btnpad' direction='row' gap='medium' justify='start'>
                        <Button className='btnsquare' href='/Home/Movimenti' label='Movimenti' color='transparent' onClick={() => this.keepAlive(window.location.href + '/Movimenti', 0)} />
                        <Button className='btnsquare btnsquaremargin' href='/Home/Riepilogo' label='Riepilogo' color='transparent' onClick={() => this.keepAlive(window.location.href +'/Riepilogo', 1)} />
                    </Box>
                    <Box className='btnpad' direction='row' gap='medium' justify='end'>
                        <Button className='btnsquare' href='/Home/StatisticaMensile' label='Statistica Mensile' color='transparent' />
                        <Button className='btnsquare' href='/Home/StatisticaTrimestrale' label='Statistica Trimestrale' color='transparent' />
                    </Box>
                </Box>
                <Box className='generic' direction='row' justify='center'>
                    <Box className='btnpadlast' direction='row' gap='medium' justify='center'>
                        <Button className='btnsquare' href='/Home/StatisticaSemestrale' label='Statistica Semestrale' color='transparent' />
                        <Button className='btnsquare btnsquaremargin' href='/Home/DettaglioDifferenzeContabili' label='Dettaglio Differenze Contabili' color='transparent' onClick={() => this.keepAlive(window.location.href +'/DettaglioDifferenzeContabili', 2)} />
                    </Box>
                    <Box className='btnpadlast' direction='row' gap='medium' justify='center'>
                        <Button className='btnsquarelast' href='/Home/AddebitiContestazioni' label='Addebiti/accrediti generati da contestazioni' color='transparent' onClick={() => this.keepAlive(window.location.href +'/AddebitiContestazioni', 3)} />
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default MainButtons = withRouter(MainButtons);
